import type { SpaceIdentity } from '../types';

export class Space implements SpaceIdentity {
  private constructor(
    readonly spaceCode: string,
    readonly spaceName: string,
  ) {}

  static init() {
    return new Space('', '');
  }

  static fromRaw(raw: SpaceRaw) {
    return new Space(raw.spaceCode, raw.spaceName);
  }

  static fromRaws(raws: SpaceRaw[]) {
    return raws.map(Space.fromRaw);
  }
}

/** Space の Raw。一覧 API と `GET /space/current` のどちらの行もこの形で読む。 */
export interface SpaceRaw {
  spaceCode: string;
  spaceName: string;
}
